import { FunctionComponent } from 'react';

import { NutritionalValue } from '@/atoms';

import { TypeNutritionalValueGroupProps } from './types';

/**
 * NutritionalValueGroup
 */
export const NutritionalValueGroup: FunctionComponent<
  TypeNutritionalValueGroupProps
> = ({ className = '', values }: TypeNutritionalValueGroupProps) => (
  <div className={`flex flex-row gap-7 text-center ${className}`}>
    {values.map((value, index: number) => (
      <NutritionalValue name={value.name} value={value.value} key={index} />
    ))}
  </div>
);

NutritionalValueGroup.displayName = 'NutritionalValueGroup';
